"use client";

import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Box } from "@revoo/design-system/ui/Box/Box";
import { Alert } from "@revoo/design-system/ui/Alert/Alert";
import { SlideWrap } from "@revoo/design-system/ui/Animation/Slide/Slide";
import { selectMessageHandler } from "@/libs/shared/messages/selectors";
import { resetMessageHandler } from "@/libs/shared/messages/messages.slice";

export default function MessageHandler() {
  const dispatch = useDispatch();
  const selector = useSelector(selectMessageHandler);

  const resetMessage = useCallback(() => {
    dispatch(resetMessageHandler());
  }, [dispatch]);

  useEffect(() => {
    if (!selector?.title) return;

    // Gli errori restano più a lungo: possono contenere un codice che chiediamo
    // al PT di riportarci, e in tre secondi non si fa in tempo a leggerlo
    // (RV-2039). Restano comunque richiudibili con un click.
    const timer = setTimeout(
      () => {
        resetMessage();
      },
      selector?.type === "error" ? 12000 : 3000,
    );
    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, resetMessage, selector?.title, selector?.type]);

  return selector.title && selector?.type ? (
    <Box
      position="fixed"
      top={{
        sm: selector.title && selector.type ? "65px" : 0,
      }}
      bottom={{
        base: selector.title && selector.type ? "85px" : 0,
        sm: "auto",
      }}
      right={
        selector.title &&
        selector?.type && {
          base: 4,
          sm: 8,
        }
      }
      left={
        selector.title &&
        selector?.type && {
          base: 4,
          sm: "auto",
        }
      }
      zIndex={9999}
    >
      <SlideWrap isOpen={true}>
        <Alert
          title={selector?.title}
          subtitle={selector?.subtitle}
          status={selector?.type}
          onClick={resetMessage}
          minW={{
            base: "100%",
            sm: "380px",
          }}
        />
      </SlideWrap>
    </Box>
  ) : null;
}
